import * as React from "react";

import { RouteComponentProps } from "react-router";
import { API_CompoId } from "../../../../src/apidefs";
import { api } from "../../api";
import { SubmissionSection } from "../CompoPage";
import { Compo } from "../../models/compos";

interface SubmitToCompoState {
  compo: API_CompoId | undefined;
}

interface SubmitToCompoProps extends RouteComponentProps<{ id: string }> {}

export default class SubmitEntryPage extends React.Component<
  SubmitToCompoProps,
  SubmitToCompoState
> {
  state: SubmitToCompoState = {
    compo: undefined,
  };

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  async componentWillReceiveProps(
    _newProps: SubmitToCompoProps
  ): Promise<void> {
    const compo_id = Number(this.props.match.params.id);
    const compo = await api.get<"/api/compo/:id">(`/api/compo/${compo_id}`);

    if (!api.isToast(compo)) this.setState({ compo });
  }

  render(): JSX.Element {
    if (!this.state.compo) {
      return <div> Loading </div>;
    }

    return (
      <div>
        <SubmissionSection
          compo={new Compo(this.state.compo.compo)}
          entriesSubmitted={this.state.compo.entriesSubmitted}
          onCreateEntry={() => {}}
        />
      </div>
    );
  }
}
